import * as yup from 'yup';

const name = yup.string().required('Name is required');
const number = yup
  .string()
  .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, 'Invalid number format')
  .required('Number is required');
const email = yup.string().email('Invalid email format').required('Email is required');
const companyName = yup.string().required('Company Name is required');
const comments = yup.string().required('Please enter your comments');

export const publicSchema = yup.object().shape({
  name,
  number,
  email,
  comments,
});

export const agentSchema = yup.object().shape({
  name,
  number,
  email,
  companyName,
  comments,
});
